export default "__VITE_ASSET__BGuGmFwR__"